"use strict";
var EmptyObservable_1 = require('./EmptyObservable');
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3659550778/src/~/rxjs/observable/empty.js
// module id = slZm
// module chunks = 6